const cancelledStatuses = new Set(["cancelled", "canceled"]);

export const isCancelledShuttleParticipant = (participant = {}) =>
  [
    participant.pickupCheckInStatus,
    participant.status,
    participant.rsvpStatus,
  ].some((status) =>
    cancelledStatuses.has(String(status || "").trim().toLowerCase()),
  ) || String(participant.needRide || "").trim().toLowerCase() === "no";

export const activeShuttleParticipants = (participants = []) =>
  (Array.isArray(participants) ? participants : []).filter(
    (participant) => !isCancelledShuttleParticipant(participant),
  );
